module.exports = __webpack_public_path__ + "static/media/thief.8d983f93.gif";